import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { ResetClickType, aIChatPlaygroundContext, aIChatPlaygroundResetModalId } from '../../aIChatPlaygroundConstants';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import { SlConfirmationModal } from '../../../../shared/public/SlConfirmationModal/SlConfirmationModal';
import s from './AIChatPlaygroundReset.scss';
import { Container, ModalService, i18n } from '../../../../symphony';
import { AIChatPlaygroundService } from '../../services/AIChatPlaygroundService';
import { AIChatPlaygrountTrackingService } from '../../services/AIChatPlaygrountTrackingService';
import { ResetIcon } from '../../../../shared/public/assets/icons/ResetIcon';

export const AIChatPlaygroundReset = ({ noInput }: { noInput?: boolean; }) => {
	useStyles(s);
	const { isResponseLoading, isInitialState } = useContainerData(
		aIChatPlaygroundContext.value,
		AIChatPlaygroundStore,
		['isResponseLoading', 'isInitialState'],
	);
	const trackingService = Container.take(aIChatPlaygroundContext.value, AIChatPlaygrountTrackingService);
	const modalService = Container.take('global', ModalService);
	const aIChatPlaygroundService = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);
	const onResetButtonClick = () => {
		trackingService.trackPlaygroundReset(ResetClickType.ResetButtonClick);
		modalService.open(aIChatPlaygroundResetModalId);
	};
	const onCloseConfirmationModal = () => {
		trackingService.trackPlaygroundReset(ResetClickType.ConfirmReset);
		modalService.close(aIChatPlaygroundResetModalId);
		aIChatPlaygroundService.resetConversation();
	};

	return (
		<>
			<div className={classNames(
				'ai-chat-playground-reset',
				!isInitialState && !isResponseLoading && 'active',
				noInput && 'no-input',
			)}
			>
				<ResetIcon
					onClick={onResetButtonClick}
				/>
			</div>
			<SlConfirmationModal
				title={i18n.t('ai-chat.reset.title')}
				info={i18n.t('ai-chat.reset.description')}
				actions={[{
					name: i18n.t('ai-chat.reset.confirm'),
					btnType: 'primary',
					handler: onCloseConfirmationModal,
				}]}
				modalId={aIChatPlaygroundResetModalId}
				closeBtnCallback={() => { trackingService.trackPlaygroundReset(ResetClickType.CancelReset); }}
			/>
		</>
	);
};
